export const getProductVariantKey = ({ variantId, type, productId }) => (
  `${variantId}:${type}:${productId}`
);

export const mergeProductVariants = (existing = [], incoming = []) => {
  const result = existing.map((item) => ({ ...item }));

  incoming.forEach((variant) => {
    const key = getProductVariantKey(variant);
    const idx = result.findIndex((item) => getProductVariantKey(item) === key);

    if (idx > -1) {
      result[idx].numberOfAssets = (result[idx].numberOfAssets || 1) + 1;
    } else {
      result.push({ ...variant, numberOfAssets: 1 });
    }
  });

  return result;
};

export const mapAssetProductVariants = (variants = []) => (
  variants.map((variant) => ({ ...variant, numberOfAssets: 1 }))
);
